import { render, staticRenderFns } from "./PricePlanList.vue?vue&type=template&id=03626ece&"
import script from "./PricePlanList.vue?vue&type=script&lang=js&"
export * from "./PricePlanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports